import dayjs from 'dayjs';
import invariant from 'tiny-invariant';

import type { UpdateDraftQuotationPayload, UpdateQuotationPayload } from '~/api/quotations';

import { flattenFormSectionsToLines } from '~/features/documents';

import type { CreateEditQuotationFormType } from './CreateEditQuotation/types';

export const mapQuotationFormDataToDraftPayload = (data: CreateEditQuotationFormType) =>
  ({
    brandId: data.brandId,
    clientContactId: data.contactId,
    clientId: data.clientId,
    conditionId: data.condition?.type === 'condition' ? data.condition.id : null,
    customAgreementId: data.condition?.type === 'customAgreement' ? data.condition.id : null,
    customConditionId: data.condition?.type === 'customCondition' ? data.condition.id : null,
    description: data.description,
    coEntryNumber: data.coEntryNumber,
    expirationDate: data.expirationDate ? dayjs(data.expirationDate).format() : null,
    introduction: data.introduction,
    mail: data.mail,
    quotationLines: data.sections ? flattenFormSectionsToLines(data.sections) : [],
    specialConditions: data.specialConditions,
    title: data.title,
  }) satisfies UpdateDraftQuotationPayload;

export const mapQuotationFormDataToPayload = (data: CreateEditQuotationFormType) => {
  // Narrow types of required fields
  invariant(data.brandId !== null, 'Expected brandId to be defined.');
  invariant(data.clientId !== null, 'Expected clientId to be defined.');
  invariant(data.contactId !== null, 'Expected contactId to be defined.');
  invariant(data.condition !== null, 'Expected condition to be defined.');
  invariant(data.expirationDate, 'Expected expirationDate to be defined.');

  return {
    brandId: data.brandId,
    clientContactId: data.contactId,
    clientId: data.clientId,
    conditionId: data.condition.type === 'condition' ? data.condition.id : null,
    customAgreementId: data.condition.type === 'customAgreement' ? data.condition.id : null,
    customConditionId: data.condition.type === 'customCondition' ? data.condition.id : null,
    description: data.description,
    coEntryNumber: data.coEntryNumber,
    expirationDate: dayjs(data.expirationDate).format(),
    introduction: data.introduction,
    mail: data.mail,
    quotationLines: flattenFormSectionsToLines(data.sections),
    specialConditions: data.specialConditions,
    title: data.title,
  } satisfies UpdateQuotationPayload;
};
